/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PantallaInicioIdDto } from '../../models/pantalla-inicio-id-dto';

export interface PantallaInicioControllerObtenerPantallaInicioPorUsuario$Params {
}

export function pantallaInicioControllerObtenerPantallaInicioPorUsuario(http: HttpClient, rootUrl: string, params?: PantallaInicioControllerObtenerPantallaInicioPorUsuario$Params, context?: HttpContext): Observable<StrictHttpResponse<PantallaInicioIdDto>> {
  const rb = new RequestBuilder(rootUrl, pantallaInicioControllerObtenerPantallaInicioPorUsuario.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PantallaInicioIdDto>;
    })
  );
}

pantallaInicioControllerObtenerPantallaInicioPorUsuario.PATH = '/api/pantalla-inicio/obtener-pantalla-inicio';
